import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Ah sranje",
  "description": "",
  "published": "2006-11-07T00:00:00.000Z",
  "redirect_from": ["/blog/ah-sranje/swizec/367"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Vceraj je bil, kot kaze, okoli naokoli in oh in sploh slab dan. Bil sem prezaposlen s spanjem pred televizijo v dnevni sobi, da bi napisal kako misel v "dnevni" blog in v upanju, da se kaj podobnega ne ponovi danes, ga pisem ze tako zgodaj kot ob 1700 ... kot da je to tako zelo zgodaj, ampak hej, vse je super ce je blog napisan.`}</p>
    <p>{`Na zalost, ne. Zaradi te ali one stvari se je po cistem nakljucju zgodilo tako, da ze od petka nisem napisal vsega skupaj vec kot 1000 besed, kar me postavi tako dalec za nacrti, da je prevec strasno sploh izracunati pravzaprav kako dalec. Cisto po pravici, mislim, da bi v tem trenutku bilo brezsmiselno se prevec nervrirati okoli stevila besed, saj bi to povzrocilo razpolozenje, ki sploh ni primerno za delo. Osredotocil se bom, torej, na pisanje samo in pustil stetje besed za drugic.`}</p>
    <p>{`Po drugi strani pa sem danes v soli uspel napisati celih 300 besed ... juhu .. na zalost je to tudi vse kar sem danes uspel napisati ...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      